import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
    CompanyInvitationFromDb,
    MentorConnectedUser,
    TtoLeadsFromDb
} from '../interfaces/responsedata.ts/mentor';
import { serverurl } from './../../environments/environment';
import { SnackService } from './snack.service';

@Injectable({
    providedIn: 'root',
})
export class MentorService {
    http = inject(HttpClient);
    snack = inject(SnackService);
    serverurl = serverurl;

    constructor() { }

    async activateUserGate(connectedUserId: string, gateIndex: number): Promise<boolean> {
        return new Promise((resolve) => {
            this.http.post(`${serverurl}/mentor/activate-gate/`, { connectedUserId, gateIndex }).subscribe({
                next: (data: any) => {
                    this.snack.success(data.msg);
                    resolve(true);
                },
                error: (error) => {
                    this.snack.success(error);
                    resolve(false);
                },
            });
        });
    }

    async grantAccessForUserInvitation(leadId: string): Promise<boolean> {
        return new Promise((resolve) => {
            this.http.post(`${serverurl}/mentor/new-invites/`, { leadId }).subscribe({
                next: (data: any) => {
                    this.snack.success(data.msg);
                    resolve(true);
                },
                error: (error) => {
                    this.snack.success(error);
                    resolve(false);
                },
            });
        });
    }
    async declineUserInvitation(leadId: string): Promise<boolean> {
        return new Promise((resolve) => {
            this.http.delete(`${serverurl}/mentor/new-invites/${leadId}`).subscribe({
                next: (data: any) => {
                    this.snack.success(data.msg);
                    resolve(true);
                },
                error: (error) => {
                    this.snack.success(error);
                    resolve(false);
                },
            });
        });
    }
    async getNewInviteesByMentorId(
        search?: string,
    ): Promise<TtoLeadsFromDb[] | false> {
        return new Promise((resolve) => {
            let params = new HttpParams();

            if (search) {
                params = params.append('search', search);
            }

            this.http.get(`${serverurl}/mentor/new-invites`, { params }).subscribe({
                next: (data: any) => {
                    resolve(data);
                },
                error: (error) => {
                    this.snack.success(error);
                    resolve(false);
                },
            });
        });
    }
    async getAllConnectedUserByMentorId(
        search?: string,
    ): Promise<{ totalData: MentorConnectedUser[], updatedLicense: { licenseType: string, role: string[], credits: number, totalSeats: number, freeSeats: number, expireDate: number | null }[] } | false> {
        return new Promise((resolve) => {
            let params = new HttpParams();

            if (search) {
                params = params.append('search', search);
            }

            this.http
                .get(`${serverurl}/mentor/connected-user`, { params })
                .subscribe({
                    next: (data: any) => {
                        resolve(data);
                    },
                    error: (error) => {
                        this.snack.success(error);
                        resolve(false);
                    },
                });
        });
    }

    async revokeAccessByFounderId(founderId: string): Promise<boolean> {
        return new Promise((resolve) => {
            this.http
                .delete(`${serverurl}/mentor/connected-user/${founderId}`)
                .subscribe({
                    next: (data: any) => {
                        this.snack.success(data.msg);
                        resolve(data);
                    },
                    error: (error) => {
                        this.snack.success(error);
                        resolve(false);
                    },
                });
        });
    }

    async getMentorInvitationLinks(): Promise<false | CompanyInvitationFromDb[]> {
        return new Promise((resolve) => {
            this.http.get(`${serverurl}/mentor/invitation-link`).subscribe({
                next: (data: any) => {
                    // this.snack.success(data.msg);
                    resolve(data);
                },
                error: (error) => {
                    this.snack.success(error);
                    resolve(false);
                },
            });
        });
    }
}
